"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KintsugiAmount = exports.Kintsugi = exports.KintsugiUnit = void 0;
const monetary_1 = require("../monetary");
exports.KintsugiUnit = {
    KINT: 12,
    Planck: 0,
};
exports.Kintsugi = {
    name: "Kintsugi",
    base: exports.KintsugiUnit.KINT,
    rawBase: exports.KintsugiUnit.Planck,
    units: exports.KintsugiUnit,
    humanDecimals: 5,
    ticker: "KINT"
};
class KintsugiAmount extends monetary_1.MonetaryAmount {
    constructor(amount, unit) {
        super(exports.Kintsugi, amount, unit ? exports.KintsugiUnit[unit] : 0);
    }
    withAmount(amount) {
        const Cls = this.constructor;
        return new Cls(amount);
    }
}
exports.KintsugiAmount = KintsugiAmount;
KintsugiAmount.from = monetary_1.generateFromConversions(exports.Kintsugi, exports.KintsugiUnit);
KintsugiAmount.zero = KintsugiAmount.from.KINT(0);
